<mat-form-field appearance="outline" class="full-width custom-mat-field">
    <!-- <mat-label>{{ label | translate}}</mat-label> -->
    <!-- <mat-select [formControl]="control" multiple [compareWith]="compareFn"> -->
    <mat-select [formControl]="control" multiple >

        <mat-option *ngFor="let option of options" [value]="option[valueKey]">
            {{ option[labelKey] }}
        </mat-option>
        
    </mat-select>
    <mat-error *ngIf="control?.invalid && (control?.dirty || control?.touched)">
        {{ errorMessage }}
    </mat-error>
</mat-form-field>